import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Button, Col, Divider, Form, Row, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import {
  clearSettingsResult,
  loadSettingsStatus,
  setPhoneNumber,
} from "../../store/user/general/userActions";
import CustomInput from "../shared/form/reactHookForm/CustomInput";

const layout = { labelCol: { span: 15 }, wrapperCol: { span: 9 } };

const updatePhoneSchema = yup.object().shape({
  PhoneNumber: yup
    .string()
    .required("Please enter your phone number.")
    .matches(/^\d+$/, "Phone number must contain only numbers.")
    .length(10, "Phone number must be exactly 10 digits."),
  PhoneNumberConfirmation: yup
    .string()
    .required("Please confirm your phone number.")
    .oneOf([yup.ref("PhoneNumber"), null], "Phone numbers do not match."),
});

const UpdatePhoneNumber = ({ onCloseHandler }) => {
  //
  const {
    control,
    handleSubmit,
    trigger,
    formState: { isValid, isDirty },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      PhoneNumber: "",
      PhoneNumberConfirmation: "",
    },
    resolver: yupResolver(updatePhoneSchema),
  });

  //
  const dispatch = useDispatch();
  const operationResult = useSelector(
    (state) => state.user.general.settings.operationResult
  );
  const loading = useSelector((state) => state.user.general.settings.loading);
  const [alertMessage, setAlertMessage] = useState(null);

  //
  useEffect(() => {
    dispatch(clearSettingsResult());
    return () => {
      dispatch(clearSettingsResult());
    };
  }, [dispatch]);

  useEffect(() => {
    if (operationResult) {
      setAlertMessage({
        type: operationResult.Outcome === "Success" ? "success" : "error",
        text: operationResult.Message,
      });
      if (operationResult.Outcome === "Success") {
        dispatch(loadSettingsStatus());
      }
    }
  }, [operationResult]);

  //
  const onSubmitHandler = (values) => {
    setAlertMessage(null);
    dispatch(setPhoneNumber(values.PhoneNumber));
  };

  return (
    <Spin spinning={loading} delay={500}>
      <Form
        size="small"
        autoComplete="off"
        name="updatePhoneNumber"
        onFinish={handleSubmit(onSubmitHandler)}
      >
        {alertMessage && (
          <Alert
            style={{ marginBottom: "20px" }}
            type={alertMessage.type}
            message={alertMessage.text}
            showIcon
          />
        )}

        <CustomInput
          style={{ width: "120px" }}
          required
          control={control}
          formLabel="Phone Number"
          name="PhoneNumber"
          layout={layout}
          autoComplete="tel"
          type="tel"
          maxLength={10}
          onBlur={() => {
            trigger();
          }}
        />

        <CustomInput
          style={{ width: "120px" }}
          required
          control={control}
          formLabel="Confirm Phone Number"
          name="PhoneNumberConfirmation"
          layout={layout}
          autoComplete="tel"
          type="tel"
          maxLength={10}
        />

        <Divider style={{ marginBottom: 12, marginTop: 0 }} />

        <Row>
          <Col span={24}>
            <Space>
              <Button
                size="small"
                type="primary"
                id="saveButton"
                htmlType="submit"
                disabled={!isValid || !isDirty}
              >
                Update
              </Button>
              <Button onClick={() => onCloseHandler()} type="dashed">
                Close
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default UpdatePhoneNumber;
